import { render } from "./TransferOwnershipModal.vue?vue&type=template&id=22135923&scoped=true"
import script from "./TransferOwnershipModal.vue?vue&type=script&lang=js"
export * from "./TransferOwnershipModal.vue?vue&type=script&lang=js"

import "./TransferOwnershipModal.vue?vue&type=style&index=0&id=22135923&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22135923"]])

export default __exports__